import assert from '@/sui/tools/assert'
import clone from 'clone'
import checker from '@/sui/tools/checker'

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'

function binarySearch (array, pred) {
  let lo = -1
  let hi = array.length
  while (1 + lo < hi) {
    const mi = lo + ((hi - lo) >> 1)
    if (pred(array[mi])) {
      hi = mi
    } else {
      lo = mi
    }
  }
  return hi
}

function lowerBound (array, item, key) {
  return binarySearch(array, j => item <= j[key])
}

function upperBound (array, item, key) {
  return binarySearch(array, j => item < j[key])
}

function calculateMatchStartScore (string) {
  const match = string.match(this.pattern)
  return match == null ? 0 : 100
}

function calculateMatchScore (string) {
  const match = this.pattern.exec(string)
  if (match == null || match.length !== 3) {
    return 0
  }

  const match1 = match.index === 0 || match[1] != null
  const match2 = match[2] != null
  return 100000 - match.index + match1 * 10000 + match2 * 1000
}

function sortedMatches (
  search, items, limit = 10, itemKey = null, ignoreCase = true,
  restrictToMatch = true, matchStart = false
) {
  assert.isArray(items)
  if (items.length === 0 || search === '') {
    const result = []
    for (let i = 0; i !== items.length && i !== limit; ++i) {
      result.push(items[i])
    }
    return result
  }

  const searchKey = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const flags = ignoreCase ? 'i' : ''
  const patterns = []

  if (matchStart) {
    patterns.push(
      {
        pattern: new RegExp(`^${searchKey}`, flags),
        exclusive: true,
        score: calculateMatchStartScore
      }
    )
  } else {
    patterns.push(
      {
        pattern: new RegExp(`( )?${searchKey}( )?`, flags),
        exclusive: false,
        score: calculateMatchScore
      }
    )
    const values = searchKey.split(' ')
    if (values.length > 1) {
      for (let i = 0; i !== values.length; ++i) {
        const value = values[i]
        if (value.length === 0) {
          continue
        }

        patterns.push(
          {
            pattern: new RegExp(`( )?${value}( )?`, flags),
            exclusive: true,
            score: calculateMatchScore
          }
        )
      }
    }
  }

  const matches = []
  for (let i = 0; i !== items.length; i++) {
    const item = items[i]
    const key = (itemKey != null ? item[itemKey] : item).toString()
    if (restrictToMatch && key === searchKey) {
      return [item]
    }

    let score = 0
    for (let j = 0; j !== patterns.length; ++j) {
      const regexp = patterns[j]
      const keyScore = regexp.score(key)

      if (restrictToMatch && regexp.exclusive && keyScore === 0) {
        break
      }

      score += keyScore
    }

    const result = { score: score }
    const debugScore = false
    if (debug && debugScore && itemKey != null) {
      assert.notNull(item[itemKey])
      result.item = clone(item)
      result.item[itemKey] = `[@${score}] | ${result.item[itemKey]}`
    } else {
      result.item = item
    }

    if (score > 0 || !restrictToMatch) {
      matches.push(result)
    }
  }

  matches.sort(
    function (a, b) { return b.score - a.score }
  )

  const result = []
  for (let i = 0; i !== matches.length && i !== limit; ++i) {
    result.push(matches[i].item)
  }

  return result
}

if (debug) {
  const c = checker('@/sui/tools/search')
  const checkList = [
    {
      search: 'urg',
      items: ['AD URG', 'AD CHIR SUR - Chirurgie'],
      expectedAnswer: 'AD URG',
      name: 'urg search test'
    },
    {
      search: 'p1',
      items: ['Adulte (p1b adulte)', 'Port conforme de la coiffe (p1 coiffe conforme)'],
      expectedAnswer: 'Port conforme de la coiffe (p1 coiffe conforme)',
      name: 'p1 search test'
    }
  ]

  for (let i = 0; i < checkList.length; i++) {
    const testValues = checkList[i]
    const result = sortedMatches(testValues.search, testValues.items)
    c.check(
      result.length === testValues.items.length,
      `${testValues.name} : invalid result length, expected ${testValues.items.length}, got ${result.length}`
    )
    c.check(
      result[0] === testValues.expectedAnswer,
      `${testValues.name} : expected ${testValues.expectedAnswer}, got ${result[0]}`
    )
  }

  c.end()
}

export default {
  binarySearch,
  lowerBound,
  upperBound,
  sortedMatches
}
